var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChapitre(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Composant_198_1",
    "data-name": "Composant 198 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.796,
    height: 17.469,
    viewBox: "0 0 14.796 17.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2252",
    "data-name": "Rectangle 2252",
    width: 8.22,
    height: 1.456,
    transform: "translate(2.288 13.059)",
    fill: "#24567b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2253",
    "data-name": "Rectangle 2253",
    width: 8.22,
    height: 1.456,
    transform: "translate(2.288 10.147)",
    fill: "#24567b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_469",
    "data-name": "Trac\\xE9 469",
    d: "M59.241,317.806h-4.11v1.456H57.6V322.9a1.559,1.559,0,0,0,1.644,1.456h4.11v9.461H51.843v-8.005H50.2v8.005a1.558,1.558,0,0,0,1.644,1.455l11.508,0A1.56,1.56,0,0,0,65,333.819V322.9Zm0,5.1v-3.036l3.428,3.036Z",
    transform: "translate(-50.199 -317.806)",
    fill: "#24567b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_470",
    "data-name": "Trac\\xE9 470",
    d: "M53.487,324.357l-1.644-.728-1.644.728v-6.551h3.288Z",
    transform: "translate(-50.199 -317.806)",
    fill: "#24567b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChapitre);
export default __webpack_public_path__ + "static/media/chapitre.2c7da0b52c6abff8533d90c41d79932f.svg";
export { ForwardRef as ReactComponent };